import { useCallback } from 'react';
import { useCommonAppStoreReviewMode } from './useAppStoreReviewMode';
import { NATIVE_COMMON_PROVIDER_ID } from '../constants/appStoreReview';

export const useAppStoreCommonGamesFilter = () => {
  const isCommonAppStoreReviewMode = useCommonAppStoreReviewMode();

  return useCallback(
    (games = []) => {
      return isCommonAppStoreReviewMode
        ? games.filter((game) => game.provider !== NATIVE_COMMON_PROVIDER_ID)
        : games;
    },
    [isCommonAppStoreReviewMode]
  );
};
